import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import "./Collective.css";
import { getImageUrl } from "../api/strapi";

function Collective({ collective }) {
  return (
    <>
      <h2 className=" font-bold text-4xl mt-16">{collective.name}</h2>
      <div className="blockrender my-4">
        <BlocksRenderer content={collective.description} />
      </div>
    </>
  );
}

export default Collective;
